// ============================================================================
// "Você já tem conta" só quando o GoTrue diz ISSO (23/09/2026).
//
// As três telas de cadastro (/welcome-hp, /welcome, /auth) tratavam QUALQUER 422
// como conta existente. O GoTrue devolve 422 também para email inválido
// (email_address_invalid) e senha fraca (weak_password): a compradora via "Sign in
// now" e tentava entrar numa conta que não existe. Achado do Codex (GPT-6 Astra)
// no porte para o Lost Prayer, relatado pela sessão APP-MOTOR, conferido aqui.
// Agora só o código ou o texto de "já existe"; o resto segue para o friendlyError,
// que tem a frase certa para email com erro e senha curta.
// Teste: src/lib/__tests__/accountExists.test.ts
// ============================================================================

export interface AuthErrorShape {
  code?: string;
  status?: number;
  message?: string;
}

export function isAccountExistsError(error: AuthErrorShape): boolean {
  const msg = error.message || '';
  return (
    error.code === 'user_already_exists' ||
    error.code === 'email_exists' ||
    /already\s+(been\s+)?(registered|used|exists)/i.test(msg) ||
    /email\s+(address\s+)?(has\s+been|already)\s+(used|registered)/i.test(msg)
  );
}
